// 引入vue核心库
import Vue from "vue";
// 引入vuex
import Vuex from "vuex";
import sys from "@/store/sys";
// 使用vuex插件
Vue.use(Vuex);
//创建并暴露store
export default new Vuex.Store({
    modules:{
        sys
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js